// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export default {
  Card: {
    select: 'Välj',
    titleLinkTooltip: 'Gå till sida',
    collapseCardTooltip: 'Kollapsa kortet',
    expandCardTooltip: 'Expandera kortet'
  },
  CardList: {
    loadMore: 'Ladda fler',
    notFound: 'Inga objekt funna.',
    toolbarSelect: 'Välj',
    viewCards: 'Kort',
    viewTiles: 'Rutor',
    viewList: 'Lista',
    toolbarView: 'Vy'
  },
  ClosingConfirmation: {
    confirm: 'Lämna',
    cancel: 'Gå tillbaka',
    content: 'Vill du verkligen stänga och lämna det här fönstret? Alla dataändringar du gjort kommer inte att sparas.'
  },
  Cuttable: {
    showMore: 'Visa mer',
    showLess: 'Visa mindre'
  },
  Dialog: {
    cancelButton: 'Avbryt'
  },
  DrawerProgress: {
    cancelButton: 'Avbryt'
  },
  Dropdown: {
    close: 'Stäng'
  },
  Form: {
    submitButton: 'Spara',
    applyButton: 'Tillämpa',
    cancelButton: 'Avbryt'
  },
  FormField: {
    clear: 'Rensa',
    remove: 'Ta bort',
    addMore: 'Lägg till ett till'
  },
  FormFieldPassword: {
    improvePassword: 'För att förbättra ditt lösenord:',
    passwordTooShort: 'Gör lösenordet längre.',
    lettersLowerCase: 'Använd minst ett gement tecken.',
    lettersUpperCase: 'Använd minst ett versalt tecken.',
    numbers1: 'Använd minst en siffra.',
    numbers3: 'Använd minst tre siffror.',
    specialChar1: 'Använd minst ett specialtecken (exempelvis: !, @, #, $, %, ^, &, *, ?, _, ~).',
    specialChar2: 'Använd minst två specialtecken (exempelvis: !, @, #, $, %, ^, &, *, ?, _, ~).',
    comboUpperAndLower: 'Använd både gemener och versaler.',
    comboLettersAndNumbers: 'Använd både siffror och tecken.',
    comboLettersNumbersSpecial: 'Använd siffror, tecken och specialtecken.',
    yourPasswordIsStrong: 'Du kan göra det ännu starkare genom att göra det längre.',
    passwordStrength: 'Lösenordsstyrkan är %%strength%%.',
    strengthVeryStrong: 'VÄLDIGT STARK',
    strengthStrong: 'STARK',
    strengthVeryWeak: 'VÄLDIGT SVAG',
    strengthWeak: 'SVAG',
    strengthMedium: 'MEDEL',
    hidePassword: 'Dölj lösenord',
    showPassword: 'Visa lösenord',
    generateButton: 'Generera',
    copyButtonHint: 'Kopiera lösenord',
    copySuccessToast: 'Lösenord har kopierats',
    generateButtonHint: 'Generera ett starkt lösenord'
  },
  InPlaceEdit: {
    editButtonHint: 'Redigera värde',
    okButtonHint: 'Spara ändringar',
    cancelButtonHint: 'Ångra ändringar'
  },
  InputFile: {
    browseButton: 'Välj fil...'
  },
  List: {
    totalRows: '%%totalRows%% objekt totalt',
    selectedRows: '%%selectedRows%% av %%totalRows%% objekt valda',
    all: 'Alla',
    allItemsOnPageSelected: 'Alla objekt på sidan har valts',
    allItemsSelected: 'Alla objekt valda',
    selectAllItems: 'Välj alla objekt',
    selectAllItemsOnPage: 'Välj alla objekt på sidan',
    deselectAll: 'Avmarkera'
  },
  ListEmptyView: {
    filteredTitle: 'Hittade inga objekt som matchar filtret',
    emptyTitle: 'Det verkar inte finnas nåt här',
    filteredDescription: 'Förfina din sökning eller ta bort vissa kriterier från filtret och försök igen.'
  },
  ListOperation: {
    cancelButton: 'Avbryt'
  },
  Pagination: {
    totalShort: 'av %%total%%',
    itemsPerPage: 'Objekt per sida',
    all: 'Alla',
    total: 'Sida %%current%% av %%total%%'
  },
  ProgressDialog: {
    closeButton: 'Stäng',
    cancelButton: 'Avbryt'
  },
  Select: {
    noOptions: 'Inga alternativ',
    placeholder: 'Välj...'
  },
  SpotPopup: {
    total: '%%current%% av %%total%%'
  },
  Toaster: {
    closeGroup: 'Stäng grupp'
  }
};